/**
 * lib-mtop 兼容 taopiaopiao 域名
 * `middleware`开发指南：https://yuque.antfin-inc.com/mtbsdkdocs/mtopjssdkdocs/zlb9dm
 */

import core from './core';

const tbmDomainMiddleware = function(next) {
  // @ts-ignore
  const options = this.options;
  const { path, subDomain, mainDomain, prefix } = core(options);
  options.prefix = prefix;
  options.subDomain = subDomain;
  options.mainDomain = mainDomain;
  options.path = path;
  next();
};
tbmDomainMiddleware.__mtop_middleware_name__ = 'tbm-domain';

export default tbmDomainMiddleware;
